module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/images/direction-C-lvl2-100.3f5b51df.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/images/direction-C-lvl2-100.png
// module id = 3389
// module chunks = 11